import { render, staticRenderFns } from "./UIControls.vue?vue&type=template&id=00b5ddf1"
import script from "./UIControls.vue?vue&type=script&lang=ts"
export * from "./UIControls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports